import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useIntl } from 'react-intl'

import { TableUrlPagination } from '../../../../ui'
import { TableActions } from '../table-actions'
import { userDataPreparation } from '../../logics'
import { USER_TABLE_ACTIONS, USER_TABLE_COLUMNS } from '../../constants'
import { userTableStyles } from './user-table.styles'

const getLookup = (combo) => {
  let lookup = {}
  combo.forEach((item) => (lookup[item.key] = item.value))
  return lookup
}

export const UserTable = () => {
  const intl = useIntl()
  const { formatMessage } = intl
  const userLoader = useSelector((state) => state.loader.users)
  const combos = useSelector((state) => state.combos)

  const data = userLoader?.data?.clientes || []
  const totalEntries = userLoader?.data?.total_solicitudes
  const search = userLoader?.config?.params
  const loading = userLoader?.loading

  const formattedColumns = useMemo(
    () =>
      [...USER_TABLE_COLUMNS, ...USER_TABLE_ACTIONS].map((column) => {
        const baseColumn = {
          accessorKey: column.field,
          header: formatMessage({ id: `pages.users.table.columns.${column.field}.title` }),
          size: column.width,
          minSize: column.width,
          maxSize: column.width,
        }

        const getCellText = (cell) => {
          let value

          if (column.comboId && combos[column.comboId]?.data) {
            const lookup = getLookup(combos[column.comboId].data)
            const cellValue = cell.getValue()
            value = lookup[cellValue] ?? cellValue ?? '--'
          } else {
            value = cell.getValue() ?? '--'
          }

          // Convertir a mayúsculas si es nombre o apellidos
          if ((column.field === 'nombre' || column.field === 'apellidos') && value !== '--') {
            return typeof value === 'string' ? value.toUpperCase() : value
          }

          return value
        }

        if (column.field === 'actions') {
          return {
            ...baseColumn,
            header: formatMessage({ id: 'global.actions' }),
            Cell: ({ row }) => {
              const isConfirmed = row.original?.confirmed
              const backgroundColor = !isConfirmed ? '#ffffdd' : 'transparent'
              return (
                <div
                  style={{
                    backgroundColor: backgroundColor,
                    height: '100%',
                    boxSizing: 'border-box',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '4px 0 4px -4px rgba(97, 97, 97, 0.5) inset',
                  }}
                >
                  <TableActions row={row} />
                </div>
              )
            },
            muiTableBodyCellProps: { align: 'center', sx: { padding: 0 } },
            muiTableHeadCellProps: { align: 'center' },
          }
        }

        return {
          ...baseColumn,
          Cell: ({ cell, row }) => {
            const isConfirmed = row.original?.confirmed
            const backgroundColor = !isConfirmed ? '#ffffdd' : 'transparent'
            return (
              <div
                style={{
                  backgroundColor: backgroundColor,
                  padding: '10px 16px',
                  height: '100%',
                  boxSizing: 'border-box',
                }}
              >
                {getCellText(cell)}
              </div>
            )
          },
          muiTableBodyCellProps: { sx: { padding: 0 } },
        }
      }),
    [combos, formatMessage]
  )

  const processedData = useMemo(() => userDataPreparation(data, { intl }), [data, intl])

  const finalTableOptions = useMemo(
    () => ({
      toolbar: false,
      selection: false,
      draggable: false,
      fixedColumns: {
        right: 1,
      },
    }),
    []
  )

  return (
    <TableUrlPagination
      columns={formattedColumns}
      options={finalTableOptions}
      totalEntries={totalEntries}
      search={search}
      data={processedData}
      isLoading={loading}
      muiTableBodyRowProps={({ row }) => ({
        sx: {
          backgroundColor: row.original?.confirmed === false ? '#ffffdd' : '#ffffff',
        },
      })}
      muiTableBodyCellProps={{
        sx: {
          backgroundColor: 'inherit !important',
        },
      }}
    />
  )
}
